import React from 'react';
import { useSelector } from 'react-redux';
import { MessengerChat } from 'react-messenger-chat-plugin';
import { number } from 'prop-types';

import { ButtonColor, ButtonLanguage, startDisplay } from './constants';

const MessengerButton = ({ height }) => {
  const { facebookMessengerId, enabledFacebookMessenger } =
    useSelector((state) => state.searchStore.currentSubsidiary) || '';
  return enabledFacebookMessenger && !!facebookMessengerId ? (
    <MessengerChat
      pageId={facebookMessengerId}
      language={ButtonLanguage}
      themeColor={ButtonColor}
      bottomSpacing={height}
      greetingDialogDisplay={startDisplay}
    />
  ) : null;
};

MessengerButton.propTypes = {
  height: number
};

export default MessengerButton;
